import { connect } from "react-redux"
import { updateDateRange } from "../../store"
import ReactGA from "react-ga"
import moment from "moment"
import { CalendarDropdown } from "@swipesense/calendar"
import "./CalendarDropdown.scss"

const mapStateToProps = ({ dateRange: { startDate, endDate } }) => ({
  startDate: moment(startDate),
  endDate: moment(endDate),
})

const mapDispatchToProps = dispatch => ({
  onUpdate: (startDate, endDate, selectionText) => {
    ReactGA.event({
      category: "Calendar",
      action: selectionText || "Custom",
      label: selectionText
        ? undefined
        : `${startDate.format("M/D/YY")}-${endDate.format("M/D/YY")}`,
    })
    dispatch(updateDateRange(startDate, endDate))
  },
})

const CalendarDropdownWithStore = connect(
  mapStateToProps,
  mapDispatchToProps
)(CalendarDropdown)

export default CalendarDropdownWithStore
